export const PPH_2126_EXAMPLES = [
  {
    titleKey: "taxCalculator.pph2126.examples.case1.title",
    objectTypeKey: "taxCalculator.pph2126.examples.case1.objectType",
    descriptionKey: "taxCalculator.pph2126.examples.case1.description",
    autoFillData: {
      employeeType: "permanent",
      calculationPeriod: "yearly",
      calculationMethod: "full_year",
      inputMode: "annual",
      taxScheme: "GROSS",
      grossSalary: 120000000,
      allowances: 240000000,
      thr: 60000000,
      bonus: 20000000,
      overtime: 10000000,
      premium: 960000,
      marriageStatus: "K",
      dependents: 0,
      hasBPJS: false,
      hasPensionContribution: true,
      customPensionAmount: 100000,
      hasZakat: true,
      customZakatAmount: 200000,
    },
  },
  // PMK 168/2023 Lampiran B contoh I.2.1.1. Tuan B's subjective tax liability
  // covers the whole year - he only started working in September - so his
  // income is not annualised. Contoh I.2.1.2 (Tuan C, below) is the one that is.
  {
    titleKey: "taxCalculator.pph2126.examples.case2.title",
    objectTypeKey: "taxCalculator.pph2126.examples.case2.objectType",
    descriptionKey: "taxCalculator.pph2126.examples.case2.description",
    autoFillData: {
      employeeType: "permanent",
      calculationPeriod: "yearly",
      calculationMethod: "partial_year",
      inputMode: "monthly",
      taxScheme: "GROSS",
      grossSalary: 15500000,
      marriageStatus: "TK",
      dependents: 0,
      hasBPJS: false,
      hasPensionContribution: true,
      customPensionAmount: 100000,
      startDate: "2024-09-01",
      endDate: "2024-12-31",
    },
  },
  // PMK 168/2023 Lampiran B contoh I.2.1.2. Same salary and months as Tuan B,
  // but the subjective tax liability itself starts in September, so the net
  // income is annualised and the tax prorated back to 4/12.
  {
    titleKey: "taxCalculator.pph2126.examples.case13.title",
    objectTypeKey: "taxCalculator.pph2126.examples.case13.objectType",
    descriptionKey: "taxCalculator.pph2126.examples.case13.description",
    autoFillData: {
      employeeType: "permanent",
      calculationPeriod: "yearly",
      calculationMethod: "annualized",
      inputMode: "monthly",
      taxScheme: "GROSS",
      grossSalary: 15500000,
      marriageStatus: "TK",
      dependents: 0,
      hasBPJS: false,
      hasZakat: true,
      customZakatAmount: 775000,
      startDate: "2024-09-01",
      endDate: "2024-12-31",
    },
  },
  {
    titleKey: "taxCalculator.pph2126.examples.case3.title",
    objectTypeKey: "taxCalculator.pph2126.examples.case3.objectType",
    descriptionKey: "taxCalculator.pph2126.examples.case3.description",
    autoFillData: {
      employeeType: "permanent",
      calculationPeriod: "monthly",
      taxScheme: "GROSS_UP",
      grossSalary: 51827997,
      marriageStatus: "TK",
      dependents: 0,
      hasBPJS: true,
    },
  },
  {
    titleKey: "taxCalculator.pph2126.examples.case4.title",
    objectTypeKey: "taxCalculator.pph2126.examples.case4.objectType",
    descriptionKey: "taxCalculator.pph2126.examples.case4.description",
    autoFillData: {
      employeeType: "permanent",
      calculationPeriod: "monthly",
      taxScheme: "GROSS",
      grossSalary: 6500000,
      allowances: 300000,
      marriageStatus: "K",
      dependents: 2,
      hasBPJS: false,
      startDate: "2024-07-01",
    },
  },
  {
    titleKey: "taxCalculator.pph2126.examples.case5.title",
    objectTypeKey: "taxCalculator.pph2126.examples.case5.objectType",
    descriptionKey: "taxCalculator.pph2126.examples.case5.description",
    autoFillData: {
      employeeType: "retired",
      calculationPeriod: "yearly",
      calculationMethod: "full_year",
      inputMode: "monthly",
      grossSalary: 6300000,
      marriageStatus: "K",
      dependents: 2,
    },
  },
  {
    titleKey: "taxCalculator.pph2126.examples.case6.title",
    objectTypeKey: "taxCalculator.pph2126.examples.case6.objectType",
    descriptionKey: "taxCalculator.pph2126.examples.case6.description",
    autoFillData: {
      employeeType: "non-permanent",
      calculationPeriod: "monthly",
      isMonthly: false,
      wageType: "daily",
      grossSalary: 500000,
      workingDays: 20,
      marriageStatus: "TK",
      dependents: 0,
    },
  },
  {
    titleKey: "taxCalculator.pph2126.examples.case7.title",
    objectTypeKey: "taxCalculator.pph2126.examples.case7.objectType",
    descriptionKey: "taxCalculator.pph2126.examples.case7.description",
    autoFillData: {
      employeeType: "non-permanent",
      calculationPeriod: "monthly",
      isMonthly: false,
      wageType: "contract",
      contractTotal: 4500000,
      workingDays: 10,
      marriageStatus: "TK",
      dependents: 0,
    },
  },
  {
    titleKey: "taxCalculator.pph2126.examples.case8.title",
    objectTypeKey: "taxCalculator.pph2126.examples.case8.objectType",
    descriptionKey: "taxCalculator.pph2126.examples.case8.description",
    autoFillData: {
      employeeType: "freelance",
      calculationPeriod: "monthly",
      grossSalary: 7000000,
    },
  },
  {
    titleKey: "taxCalculator.pph2126.examples.case9.title",
    objectTypeKey: "taxCalculator.pph2126.examples.case9.objectType",
    descriptionKey: "taxCalculator.pph2126.examples.case9.description",
    autoFillData: {
      employeeType: "activity-participant",
      calculationPeriod: "monthly",
      grossSalary: 200000000,
    },
  },
  {
    titleKey: "taxCalculator.pph2126.examples.case10.title",
    objectTypeKey: "taxCalculator.pph2126.examples.case10.objectType",
    descriptionKey: "taxCalculator.pph2126.examples.case10.description",
    autoFillData: {
      employeeType: "pension-withdrawal",
      calculationPeriod: "monthly",
      grossSalary: 20000000,
    },
  },
  {
    titleKey: "taxCalculator.pph2126.examples.case11.title",
    objectTypeKey: "taxCalculator.pph2126.examples.case11.objectType",
    descriptionKey: "taxCalculator.pph2126.examples.case11.description",
    autoFillData: {
      employeeType: "former-employee",
      calculationPeriod: "monthly",
      grossSalary: 60000000,
    },
  },
  {
    titleKey: "taxCalculator.pph2126.examples.case12.title",
    objectTypeKey: "taxCalculator.pph2126.examples.case12.objectType",
    descriptionKey: "taxCalculator.pph2126.examples.case12.description",
    autoFillData: {
      employeeType: "non-resident",
      calculationPeriod: "monthly",
      grossSalary: 40000000,
      pph26Rate: 20,
    },
  },
];
